export default __webpack_public_path__ + "static/media/remodel1.4573acbc.png";